export default "__VITE_ASSET__BsP_ZiRt__"